import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '@/contexts/AdminAuthContext';

export const AdminProtectedRoute = ({ children }) => {
  const { authenticated, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAF8F5]" data-testid="admin-auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#D7D1C7] border-t-[#2C5545]" />
      </div>
    );
  }
  if (!authenticated) return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  return children;
};
